import * as Sentry from '@sentry/react';
import { browserTracingIntegration, replayIntegration } from '@sentry/react';
import WebApp from '@twa-dev/sdk';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import './index.css';

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: 'https://b2a5d9ade73b29cffa1c358f2a97e9c0@o4508568314511360.ingest.us.sentry.io/4509624550293504',
    environment: 'Production',
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0.005,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
      browserTracingIntegration({}),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });

  const userId = WebApp.initDataUnsafe.user?.id;
  if (userId) {
    Sentry.setUser({ id: userId });
    Sentry.setTag('telegramUserId', userId);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
